import React from 'react/addons';
import cx from 'classnames';

import SimpleChoice from 'ofs/components/simple-choice/SimpleChoice';


var PriceInput = React.createClass({
  propTypes: {
    value: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    className: React.PropTypes.string
  },

  render() {
    var {value, className} = this.props;

    var currencyValue;
    var numericValue;

    if (value) {
      currencyValue = value.slice(0, 3);
      numericValue = value.slice(4);
    }

    var classes = {
      'ofs-Input__Wrapper': true
    };

    if (className) {
      classes[className] = true;
    }

    return (
      <div className={cx(classes)}>
        <div className="ofs-Input__Prefix">
          <SimpleChoice ref="currency"
            value={currencyValue} onChange={this.onChange}>
            <div value="USD">$ USD</div>
            <div value="GBP">£ GBP</div>
            <div value="EUR">€ EUR</div>
            <div value="AUD">$ AUD</div>
            <div value="CAD">$ CAD</div>
            <div value="BRL">R$ BRL</div>
            <div value="INR">₹ INR</div>
          </SimpleChoice>
        </div>
        <div className="ofs-Input__Value">
          <input className="ofs-Input ofs-Input--text" ref="numeric"
            type="number" onChange={this.onChange} value={numericValue} />
        </div>
      </div>
    );
  },

  onChange() {
    var currencyValue = this.refs['currency'].getSelectedValue();
    var numericValue = this.refs['numeric'].getDOMNode().value;
    var value = null;

    // set default currency
    if (!currencyValue) {
      currencyValue = 'USD';
    }

    if (currencyValue && numericValue) {
      value = `${ currencyValue }|${ numericValue }`;
    }
    this.props.onChange(value);
  }
});

export default PriceInput;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/inputs/price.jsx
 **/